import { styled, Box } from '@material-ui/core';

const Header = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  width: '100%',
  alignItems: 'center',
  borderBottom: `1px solid ${theme.palette.grey[300]}`,
}));

const SleepioHeader = styled(Box)({
  position: 'relative',
  display: 'flex',
  width: '100%',
  justifyContent: 'center',
  height: '88px',
  alignItems: 'center',
  flexWrap: 'wrap',
});

const LegalLinks = styled(Box)({
  display: 'flex',
  flex: 1,
  width: '100%',
  '@media (min-width: 600px)': {
    width: '80%',
  },
  justifyContent: 'space-evenly',
  flexWrap: 'wrap',
  marginTop: 8,
});

export default {
  Header,
  SleepioHeader,
  LegalLinks,
};
